module.exports = __webpack_public_path__ + "img/verifySignBanner.67597e66.png";